import React, { useContext, useEffect, useState } from 'react'
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/MultiSelectEntity'
import Popup from '../Common/Popup';
import useModule from '../../hooks/useModule';

/**
 * The `StateFilter` function is a React component that renders a filter for selecting states, with
 * options for selecting all states or individual states.
 * @returns a JSX element.
 */
function StateFilter({ StateOptions, setStateOptions, isCharge, customPathname, onChange, filterPathkey = "state", label="State", innerState, isPopupOpen, setIsPopupOpen }) {
    const { refineSearchFilters, accessControl } = useContext(PeFilterContext);
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;
    const { isPE, isVC, isMA } = useModule();

    useEffect(() => {
        const ids = refineSearchFilters[customPathname]?.[filterPathkey]?.map(value => value.id) ?? [];
        setStateOptions(StateOptions?.map(option => ({ ...option, isChecked: ids.includes(option.id) })))
    }, [customPathname, refineSearchFilters,filterPathkey])

    const handleStateChange = (e) => {
        const { name, checked, id, selectedEntities, filteredIds } = e.target;
        let updatedStates;
    
        if (name === "allSelect") {
            updatedStates = StateOptions.map(state => ({ ...state, isChecked: checked }));
        } else if (name === "filteredSelect" && filteredIds) {
            updatedStates = StateOptions.map(state => ({
                ...state,
                isChecked: filteredIds.includes(state.id) ? checked : state.isChecked
            }));
        } else if (name === "selectedEntities" && selectedEntities) {
            const selectedEntityIds = selectedEntities.map(entity => entity.id);
            updatedStates = StateOptions.map(state => ({
                ...state,
                isChecked: selectedEntityIds.includes(state.id) ? !state.isChecked : state.isChecked
            }));
        } else {
            updatedStates = StateOptions.map(state =>
                state.id === (isCharge ? id : parseInt(id)) ? { ...state, isChecked: checked } : state
            );
        }
    
        setStateOptions(updatedStates);
        onChange(updatedStates);
    };

    const selectedStateCount = StateOptions?.filter(option => option.isChecked)?.length ?? 0

    const enabledStates = accessControl ? (isPE || isVC ? accessControl?.pe_states?.id : isMA && label !== "Acquirer State" ? accessControl.ma_states?.id : []) : [];

    const disabledStates = enabledStates?.length > 0 ? StateOptions?.filter(op => !enabledStates?.includes(op.id)) : [];

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100  text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{label} <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. Maharashtra, Karnataka</span></span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selectedStateCount > 0 && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selectedStateCount}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)} label={label}>
                    <div className="p-4">
                        <MultiSelectEntity
                            handleEntityChange={handleStateChange}
                            primaryEntity={StateOptions}
                            disabled={disabledStates}
                        />
                    </div>
                </Popup>
            )}
        </div>
    )
}

export default StateFilter